export var SiemTrialTestSubject;
(function (SiemTrialTestSubject) {
    SiemTrialTestSubject["HeaderButton"] = "siem-trial-header-button";
    SiemTrialTestSubject["ManageAccountsLink"] = "siem-trial-manage-accounts-link";
    SiemTrialTestSubject["ConfirmTrialButton"] = "siem-confirm-trial-button";
    SiemTrialTestSubject["DeclineTrialButton"] = "siem-decline-trial-button";
    SiemTrialTestSubject["UserMenuButton"] = "siem-trial-user-menu-button";
})(SiemTrialTestSubject || (SiemTrialTestSubject = {}));
//# sourceMappingURL=siem-trial.enum.js.map